// Account auth screen — Login / Create-account tab switch + password
// show-hide. Markup is the custom WooCommerce override at
// woocommerce/myaccount/form-login.php.

(function () {
    function init() {
        const root = document.querySelector('[data-hg-auth]');
        if (!root) return;

        // ── Tabs ────────────────────────────────────────────────
        const tabs   = Array.from(root.querySelectorAll('[data-hg-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-hg-panel]'));

        const activate = (name) => {
            tabs.forEach((t) => {
                const on = t.dataset.hgTab === name;
                t.classList.toggle('is-active', on);
                t.setAttribute('aria-selected', on ? 'true' : 'false');
            });
            panels.forEach((p) => {
                p.classList.toggle('is-active', p.dataset.hgPanel === name);
            });
        };

        tabs.forEach((t) => {
            t.addEventListener('click', () => activate(t.dataset.hgTab));
        });

        // Deep-link: /my-account/?tab=register opens the register tab.
        try {
            const wanted = new URLSearchParams(window.location.search).get('tab');
            if (wanted && tabs.some((t) => t.dataset.hgTab === wanted)) activate(wanted);
        } catch (_) {}

        // ── Password show / hide ─────────────────────────────────
        root.querySelectorAll('[data-hg-password-toggle]').forEach((btn) => {
            btn.addEventListener('click', () => {
                const wrap  = btn.closest('[data-hg-password]');
                const input = wrap && wrap.querySelector('input');
                if (!input) return;
                const reveal = input.type === 'password';
                input.type = reveal ? 'text' : 'password';
                btn.classList.toggle('is-shown', reveal);
                btn.setAttribute('aria-label', reveal ? 'Hide password' : 'Show password');
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
